import { Translation, en, zh } from "@/data/lang";
import { Lang } from "@/i18n-config";

export const getTranslations = (lang: Lang): { t: Translation } => ({
  t: lang === "zh" ? zh : en,
});
